module.exports = __webpack_public_path__ + "img/stock_firm.ea8e043.png";